import { render, staticRenderFns } from "./TabContrat.vue?vue&type=template&id=608a47e8"
import script from "./TabContrat.vue?vue&type=script&lang=js"
export * from "./TabContrat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports